import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';
import { BADGE, IBadge, Status } from '@app/components/elements/badge.type';
import { ThemeType } from '@ant-design/icons-angular';

@Component({
	selector: 'app-badge-icon',
	templateUrl: './wfs-state-label.component.html',
	styleUrls: [
		'wfs-state-label.component.scss',
	],
	providers: [
		{ provide: BADGE, useExisting: WfsStateLabelComponent },
	],
})
export class WfsStateLabelComponent implements IBadge {	
	@Input()
	public label: string;
	@Input()
	@HostBinding('style.color')
	public color = 'inherit';
	@Input()
	public icon?: string;
	@Input()
	public iconTheme?: ThemeType;
	
	constructor(private readonly cdr: ChangeDetectorRef) {
	}
	
	public setStatus({ label, iconTheme, iconName, color }: Status): void {
		this.label = label;
		this.icon = iconName;
		this.iconTheme = iconTheme;
		this.color = color;
		
		this.cdr.markForCheck();
	}
}
